<template>
  <div id="app" :style="appStyle">
  <template v-if="!isNotFound">
    <Header/>
  </template>
  <div class="main">
    <router-view></router-view>
  </div>
  <template v-if="!isNotFound">
    <Footer/>
    <SideBar />
    <BottomBanner />
  </template>
  </div>
</template>

<script setup>
import { provide, computed, onMounted } from 'vue'
import { useSiteConfigStore } from '@/stores/SiteConfig'
import { useHead } from '@unhead/vue'
import Header from '@/pages/components/Header/index.vue'
import Footer from '@/pages/components/Footer/index.vue'
import SideBar from '@/pages/components/Sidebar/index.vue'
import BottomBanner from '@/pages/components/BottomBanner/index.vue'
import { useRoute } from 'vue-router'

const siteConfigStore = useSiteConfigStore()
const siteConfig = siteConfigStore
const curLang = `${__SITE_PROFILE__}`
// 将站点配置注入到应用中，使所有组件都可以访问
provide('siteConfig', siteConfig)

// 设置全局 CSS 变量，确保所有组件都能访问 headerMainColor
const appStyle = computed(() => ({
  '--header-main-color': siteConfigStore.headerMainColor || '#FF1F59'
}))

useHead({
  title: '欧那官网',
  meta: [
    { name: 'description', content: '这是一个全局描述' },
    { name: 'keywords', content: '这是全局关键词' }
  ],
  link: [
    //防止闪动
    { rel: 'preload', as: 'image', href: `/website/images/${curLang}/logo.png` },
    { rel: 'preload', as: 'image', href: `/website/images/${curLang}/logo-white.png` },
  ]
})

const route = useRoute()
const isNotFound = computed(() => route.name === 'NotFound')


</script>

<style>
#app {
  margin: 0 auto;
}

main {
  min-height: 400px;
}

</style>